import { ActivatedRoute, Router } from '@angular/router';
var ComponentEvaluate = (function () {
    function ComponentEvaluate(route, router) {
        this.route = route;
        this.router = router;
    }
    ComponentEvaluate.prototype.ngOnInit = function () {
        console.log(this.context);
    };
    ComponentEvaluate.prototype.ngAfterViewInit = function () {
    };
    return ComponentEvaluate;
}());
export { ComponentEvaluate };



// WEBPACK FOOTER //
// ./src/app/app-home-work-show/home-work-evaluate/evaluate.ts.pre-build-optimizer.js